import dayjs from "dayjs";

export const currentYearStart =
  dayjs().subtract(1, "year").format("YYYY") + "-12-31T23:59:59.999+08:00";
export const currentYearEnd =
  dayjs().format("YYYY") + "-12-31T23:59:59.999+08:00";
export const currentYear = parseInt(dayjs().format("YYYY"));
export const lastYearStart =
  dayjs().subtract(2, "year").format("YYYY") + "-12-31T23:59:59.999+08:00";
